export default __webpack_public_path__ + "static/Punchi-Muthi-Pre-School1-5b80aebf744a037893124f07980cf5a8.jpg";